import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { mergeLeft } from 'ramda'
import { ThemeReducer } from 'app/plugins/account/components/theme/model'
import { generateComponentColors } from 'core/themes/helpers'
// import defaultTheme from 'core/themes/serenity/serenityDefault'
import lightTheme from 'core/themes/serenity/serenityLight'

export const defaultThemeState: ThemeReducer = {
  theme: null,
  components: null,
  global: null,
}

interface UpdateComponentAction {
  components: ComponentPayload[]
}

interface ComponentPayload {
  pathTo: string[]
  value: string
}

const {
  name: customThemeKey,
  reducer: themeReducers,
  actions: themeActions,
} = createSlice({
  name: 'theme',
  initialState: defaultThemeState,
  reducers: {
    updateGlobalTheme: (state, { payload }) => {
      return { ...state, global: payload }
    },
    updateThemeComponent: (state, { payload }: PayloadAction<UpdateComponentAction>) => {
      return { ...state, components: generateComponentColors(payload, state.components) }
    },
    // @ts-ignore
    updateTheme: (state, { payload }: PayloadAction<Partial<ThemeReducer>>) => {
      return mergeLeft(payload, state)
    },
    clearTheme: () => {
      return lightTheme as any
    },
  },
})

export { customThemeKey, themeActions }
export default themeReducers
